/**
 * True when a socket payload represents a customer-originated message event.
 */
export function isInboundIntervenePayload(payload) {
  if (!payload) return false;
  const origin = `${payload.origin || ''}`.toUpperCase();
  if (origin === 'INBOUND') return true;
  if (origin === 'OUTBOUND') return false;
  const lastOrigin = `${payload.last_message?.origin || ''}`.toUpperCase();
  if (lastOrigin === 'INBOUND') return true;
  if (lastOrigin === 'OUTBOUND') return false;
  return false;
}

/**
 * True when payload carries chat message content (not a pure session doc).
 */
export function isInterveneChatMessagePayload(payload) {
  if (!payload) return false;
  return Boolean(
    payload.content ||
    payload.msg_id ||
    payload.w_id ||
    payload.text ||
    payload.message
  );
}

/**
 * Resolves which sound tier to play for a background list update.
 * Returns null when no sound should play.
 */
export function resolveBackgroundMessageSoundType({
  payload,
  isActiveChat,
  existingUser,
  listChanged,
}) {
  if (!payload || isActiveChat || !listChanged) return null;
  if (!isInboundIntervenePayload(payload)) return null;
  if (!isInterveneChatMessagePayload(payload) && !payload.last_message_preview) return null;

  return existingUser ? 'backgroundMessage' : 'newConversation';
}
